import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, updateData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Tooltip } from '@mui/material';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useLocation, Link } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


function PurchaseRegisterReport() {

    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const { isAuthenticated, companyId, branchId, permissions, token, username, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, branchId, logout]);


    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };


    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    //FOR CHILD 
    const [ChildOptions, setchildOptions] = useState([]);
    const [selectedChildOption, setSelectedChildOption] = useState(null);


    const handleChildInputChange = (newValue) => newValue;
    // Handle customer selection
    const handleChildSelect = (selectedChildOption) => {
        setSelectedChildOption(selectedChildOption);

    };

    const fetchTableData = async () => {
        const itemid = 0;
        setDataItem([])
        try {
            const response = await fetchData('ReportApi', `/PurchaseRegister/${fromDate}/${toDate}/${companyId}`, token);
            if (response.responseCode === '1111') {
                setDataItem(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
        }

    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    // const handleExportExcel = () => {
    //     const excelData = [];
    //     const now = new Date();
    //     const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
    //     const headerCaption = [`Purchase Data From : ${formatDate(fromDate)} To : ${formatDate(toDate)} | Generated On: ${formattedDateTime} By : ${username}`];
    //     excelData.push(headerCaption);
    //     const headerRow = ['Bill Date', 'Bill No', 'Name', 'GST No', 'P 0', 'P 3%', 'GST 3%', 'P 5%', 'GST 5%', 'P 12%', 'GST 12%', 'P 18%', 'GST 18%', 'P 28%', 'GST 28%', 'Packing', 'Pack.GST', 'Freight', 'Freight.GST', 'TCS', 'Round', 'Total'];
    //     excelData.push(headerRow);
    //     filteredDataItem.forEach((rowData, index) => {
    //         const dataRow = [];
    //         dataRow.push(formatDate(rowData.BillDate), rowData.BillNumber, rowData.MasterName, rowData.GSTNumber, rowData.Taxable0, rowData.Taxable3, rowData.GST3, rowData.Taxable5, rowData.GST5,
    //             rowData.Taxable12, rowData.GST12, rowData.Taxable18, rowData.GST18, rowData.Taxable28, rowData.GST28, rowData.PackingAmount, rowData.PackingGST, rowData.FreightAmount, rowData.FreightGSTAmount,
    //             rowData.TCSAmount, rowData.RoundOff, rowData.TotalAmount);

    //         excelData.push(dataRow);
    //     });

    //     const ws = XLSX.utils.aoa_to_sheet(excelData);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, 'PurchaseRegister Details');
    //     XLSX.writeFile(wb, 'PurchaseRegister_Details.xlsx');
    // };


    const handleExportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Purchase Register Details');

        // Freeze header row
        worksheet.views = [{ state: 'frozen', ySplit: 2 }];

        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
        const thinBorder = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };

        // 🔹 REPORT HEADER
        worksheet.mergeCells('A1:V1'); // Adjust last column based on your field count
        const headerCell = worksheet.getCell('A1');
        headerCell.value = `Purchase Data From: ${formatDate(fromDate)} To: ${formatDate(toDate)}  | Generated On: ${formattedDateTime} By: ${username}`;
        headerCell.font = { bold: true, size: 10 };
        headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

        worksheet.addRow([]);

        // 🔹 COLUMN HEADERS
        const headerTitles = [
            'Bill Date', 'Bill No', 'Name', 'GST No',
            'P 0', 'P 3%', 'GST 3%', 'P 5%', 'GST 5%',
            'P 12%', 'GST 12%', 'P 18%', 'GST 18%',
            'P 28%', 'GST 28%', 'Packing', 'Pack.GST',
            'Freight', 'Freight.GST', 'TCS', 'Round', 'Total'
        ];

        const headerRow = worksheet.addRow(headerTitles);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: '000000' } };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' }, // Light green
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = thinBorder;
        });

        // 🔹 DATA ROWS
        filteredDataItem.forEach((rowData) => {
            const dataRow = [
                formatDate(rowData.BillDate),
                rowData.BillNumber,
                rowData.MasterName,
                rowData.GSTNumber,
                rowData.Taxable0,
                rowData.Taxable3,
                rowData.GST3,
                rowData.Taxable5,
                rowData.GST5,
                rowData.Taxable12,
                rowData.GST12,
                rowData.Taxable18,
                rowData.GST18,
                rowData.Taxable28,
                rowData.GST28,
                rowData.PackingAmount,
                rowData.PackingGST,
                rowData.FreightAmount,
                rowData.FreightGSTAmount,
                rowData.TCSAmount,
                rowData.RoundOff,
                rowData.TotalAmount
            ];

            const row = worksheet.addRow(dataRow);

            row.eachCell((cell, colNumber) => {
                cell.border = thinBorder;
                if (colNumber >= 5) { // Numeric columns
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                    cell.numFmt = '#,##0.00';
                } else { // Text columns
                    cell.alignment = { horizontal: 'left', vertical: 'middle' };
                }
            });

            // ✅ Highlight "Total" rows
            if (
                String(rowData.MasterName)?.toLowerCase().includes('total') ||
                String(rowData.BillNumber)?.toLowerCase().includes('total')
            ) {
                row.eachCell((cell) => {
                    cell.font = { bold: true };
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF4CCCC' }, // Light pink
                    };
                });
            }
        });

        // 🔹 ADJUST COLUMN WIDTHS
        worksheet.columns = [
            { width: 15 }, { width: 12 }, { width: 25 }, { width: 15 },
            { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 },
            { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 },
            { width: 10 }, { width: 10 }, { width: 10 }, { width: 12 },
            { width: 12 }, { width: 12 }, { width: 10 }, { width: 10 },
            { width: 15 }, { width: 15 }
        ];

        // 🔹 SAVE FILE
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
            new Blob([buffer]),
            `PurchaseRegister_From_${formatDate(fromDate).replace(/\//g, '-')}_To_${formatDate(toDate).replace(/\//g, '-')}.xlsx`
        );
    };


    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([
        'Bill Date',
        'Bill No.',
        'Name',
        'GST No',
        'P 0',
        'P 3%',
        'GST 3%',
        'P 5%',
        'GST 5%',
        'P 12%',
        'GST 12%',
        'P 18%',
        'GST 18%',
        'P 28%',
        'GST 28%',
        'Packing',
        'Pack.GST',
        'Freight',
        'Freight.GST',
        'TCS',
        'Round',
        'Total',
    ]);

    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };

    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };

    const grandTotal = filteredDataItem
        .filter((rowData) => rowData.MasterName === "Total")
        .reduce(
            (totals, rowData) => ({
                Taxable0: parseFloat((totals.Taxable0 + (parseFloat(rowData.Taxable0) || 0)).toFixed(2)),
                Taxable3: parseFloat((totals.Taxable3 + (parseFloat(rowData.Taxable3) || 0)).toFixed(2)),
                GST3: parseFloat((totals.GST3 + (parseFloat(rowData.GST3) || 0)).toFixed(2)),
                Taxable5: parseFloat((totals.Taxable5 + (parseFloat(rowData.Taxable5) || 0)).toFixed(2)),
                GST5: parseFloat((totals.GST5 + (parseFloat(rowData.GST5) || 0)).toFixed(2)),
                Taxable12: parseFloat((totals.Taxable12 + (parseFloat(rowData.Taxable12) || 0)).toFixed(2)),
                GST12: parseFloat((totals.GST12 + (parseFloat(rowData.GST12) || 0)).toFixed(2)),
                Taxable18: parseFloat((totals.Taxable18 + (parseFloat(rowData.Taxable18) || 0)).toFixed(2)),
                GST18: parseFloat((totals.GST18 + (parseFloat(rowData.GST18) || 0)).toFixed(2)),
                Taxable28: parseFloat((totals.Taxable28 + (parseFloat(rowData.Taxable28) || 0)).toFixed(2)),
                GST28: parseFloat((totals.GST28 + (parseFloat(rowData.GST28) || 0)).toFixed(2)),
                PackingAmount: parseFloat((totals.PackingAmount + (parseFloat(rowData.PackingAmount) || 0)).toFixed(2)),
                PackingGST: parseFloat((totals.PackingGST + (parseFloat(rowData.PackingGST) || 0)).toFixed(2)),
                FreightAmount: parseFloat((totals.FreightAmount + (parseFloat(rowData.FreightAmount) || 0)).toFixed(2)),
                FreightGSTAmount: parseFloat((totals.FreightGSTAmount + (parseFloat(rowData.FreightGSTAmount) || 0)).toFixed(2)),
                TCSAmount: parseFloat((totals.TCSAmount + (parseFloat(rowData.TCSAmount) || 0)).toFixed(2)),
                RoundOff: parseFloat((totals.RoundOff + (parseFloat(rowData.RoundOff) || 0)).toFixed(2)),
                TotalAmount: parseFloat((totals.TotalAmount + (parseFloat(rowData.TotalAmount) || 0)).toFixed(2))
            }),
            {
                Taxable0: 0,
                Taxable3: 0,
                GST3: 0,
                Taxable5: 0,
                GST5: 0,
                Taxable12: 0,
                GST12: 0,
                Taxable18: 0,
                GST18: 0,
                Taxable28: 0,
                GST28: 0,
                PackingAmount: 0,
                PackingGST: 0,
                FreightAmount: 0,
                FreightGSTAmount: 0,
                TCSAmount: 0,
                RoundOff: 0,
                TotalAmount: 0,
            }
        );

    // Process and paginate the data
    const processedData = filteredDataItem.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    return (
        <div
            className="w-full mx-auto"
            style={{
                width: "100%",
                marginTop: "0",
                background: "#fff",
                border: "1px solid #dcdcdc",
                borderRadius: "6px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
        >
            {/* ===== Report Header ===== */}
            <div
                style={{
                    background: "whitesmoke",
                    color: "black",
                    padding: "5px 10px",
                    borderTopLeftRadius: "6px",
                    borderTopRightRadius: "6px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    letterSpacing: "0.5px",
                    marginTop: '-30px',
                    height: '30px'
                }}
            >
                PURCHASE REGISTER REPORT
            </div>

            {/* ===== Filter Section ===== */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px 15px",
                    borderBottom: "1px solid #eee",
                    background: "#fafafa",
                }}
            >
                {/* Search */}
                <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    style={{
                        width: isFocused ? "260px" : "200px",
                        height: "30px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "0 10px",
                        transition: "width 0.3s",
                        outline: "none",
                        fontSize: "13px",
                        marginLeft: '-15px'
                    }}
                />

                {/* Dates + Buttons */}
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    {/* From Date */}
                    <div>
                        <label style={{ fontSize: "11px", color: "#555" }}>From</label>
                        <input
                            type="date"
                            value={fromDate}
                            onChange={handleFromDateChange}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                padding: "2px 6px",
                                fontSize: "12px",
                                height: "28px",
                                marginLeft: "5px",
                            }}
                        />
                    </div>

                    {/* To Date */}
                    <div>
                        <label style={{ fontSize: "11px", color: "#555" }}>To</label>
                        <input
                            type="date"
                            value={toDate}
                            onChange={handleToDateChange}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                padding: "2px 6px",
                                fontSize: "12px",
                                height: "28px",
                                marginLeft: "5px",
                            }}
                        />
                    </div>

                    {/* Refresh */}
                    <Button
                        onClick={fetchTableData}
                        style={{
                            background: "#2f4050",
                            color: "white",
                            borderRadius: "4px",
                            padding: "5px 12px",
                            fontSize: "13px",
                            fontWeight: "bold",
                            height: "28px",
                        }}
                    >
                        Refresh
                    </Button>

                    {/* Excel */}
                    <Button
                        onClick={handleExportExcel}
                        style={{
                            background: "#00695c",
                            color: "white",
                            borderRadius: "4px",
                            padding: "5px 12px",
                            fontSize: "13px",
                            fontWeight: "bold",
                            height: "28px",
                        }}
                    >
                        Excel
                    </Button>
                </div>
            </div>

            {/* ===== Table Section ===== */}
            <div style={{ maxHeight: "540px", overflowY: "auto" }}>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columnOrder.map((col, index) => {
                                    const amountColumns = [
                                        "P 0", "P 3%", "GST 3%", "P 5%", "GST 5%", "P 12%", "GST 12%",
                                        "P 18%", "GST 18%", "P 28%", "GST 28%", "Packing", "Pack.GST",
                                        "Freight", "Freight.GST", "TCS", "Round", "Total"
                                    ];

                                    return (
                                        <TableCell
                                            key={index}
                                            style={{
                                                background: "#e9ecef",
                                                fontWeight: "bold",
                                                fontSize: "11px",
                                                padding: "3px",
                                                borderBottom: "2px solid #ccc",
                                                textTransform: "uppercase",
                                                textAlign: amountColumns.includes(col) ? "right" : "left",
                                            }}
                                        >
                                            {col}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {processedData
                                .filter((rowData) => rowData.MasterName !== "Total")
                                .map((rowData, index) => {
                                    const rowValues = {
                                        "Bill Date": rowData.BillDate ? formatDate(rowData.BillDate) : "",
                                        "Bill No.": (
                                            <a
                                                href={`/PurchaseDetails/${rowData.PurchaseId}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: "brown",
                                                    textDecoration: "none",
                                                    fontWeight: "500",
                                                }}
                                            >
                                                {rowData.BillNumber}
                                            </a>
                                        ),
                                        Name: rowData.MasterName || "",
                                        "GST No": rowData.GSTNumber || "",
                                        "P 0": rowData.Taxable0 ? parseFloat(rowData.Taxable0).toFixed(2) : "0.00",
                                        "P 3%": rowData.Taxable3 ? parseFloat(rowData.Taxable3).toFixed(2) : "0.00",
                                        "GST 3%": rowData.GST3 ? parseFloat(rowData.GST3).toFixed(2) : "0.00",
                                        "P 5%": rowData.Taxable5 ? parseFloat(rowData.Taxable5).toFixed(2) : "0.00",
                                        "GST 5%": rowData.GST5 ? parseFloat(rowData.GST5).toFixed(2) : "0.00",
                                        "P 12%": rowData.Taxable12 ? parseFloat(rowData.Taxable12).toFixed(2) : "0.00",
                                        "GST 12%": rowData.GST12 ? parseFloat(rowData.GST12).toFixed(2) : "0.00",
                                        "P 18%": rowData.Taxable18 ? parseFloat(rowData.Taxable18).toFixed(2) : "0.00",
                                        "GST 18%": rowData.GST18 ? parseFloat(rowData.GST18).toFixed(2) : "0.00",
                                        "P 28%": rowData.Taxable28 ? parseFloat(rowData.Taxable28).toFixed(2) : "0.00",
                                        "GST 28%": rowData.GST28 ? parseFloat(rowData.GST28).toFixed(2) : "0.00",
                                        Packing: rowData.PackingAmount ? parseFloat(rowData.PackingAmount).toFixed(2) : "0.00",
                                        "Pack.GST": rowData.PackingGST ? parseFloat(rowData.PackingGST).toFixed(2) : "0.00",
                                        Freight: rowData.FreightAmount ? parseFloat(rowData.FreightAmount).toFixed(2) : "0.00",
                                        "Freight.GST": rowData.FreightGSTAmount ? parseFloat(rowData.FreightGSTAmount).toFixed(2) : "0.00",
                                        TCS: rowData.TCSAmount ? parseFloat(rowData.TCSAmount).toFixed(2) : "0.00",
                                        Round: rowData.RoundOff ? parseFloat(rowData.RoundOff).toFixed(2) : "0.00",
                                        Total: rowData.TotalAmount ? parseFloat(rowData.TotalAmount).toFixed(2) : "0.00",
                                    };

                                    const amountColumns = [
                                        "P 0", "P 3%", "GST 3%", "P 5%", "GST 5%", "P 12%", "GST 12%",
                                        "P 18%", "GST 18%", "P 28%", "GST 28%", "Packing", "Pack.GST",
                                        "Freight", "Freight.GST", "TCS", "Round", "Total"
                                    ];

                                    return (
                                        <TableRow
                                            key={rowData.Id || index}
                                            sx={{
                                                backgroundColor: index % 2 === 0 ? "#fdfdfd" : "#f7f7f7",
                                                cursor: 'pointer'
                                            }}
                                        >
                                            {columnOrder.map((col, idx) => (
                                                <TableCell
                                                    key={idx}
                                                    style={{
                                                        padding: "6px",
                                                        fontSize: "12px",
                                                        borderBottom: "1px solid #e0e0e0",
                                                        textAlign: amountColumns.includes(col) ? "right" : "left",
                                                    }}
                                                >
                                                    {rowValues[col]}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>

                        <TableRow
                            key="Total"
                            sx={{ backgroundColor: '#F3F3F3', fontWeight: 'bold' }}
                        >
                            {columnOrder.map((col, idx) => {
                                let cellStyle = {};
                                let cellValue = '';

                                if (col === 'P 0') {
                                    //  cellValue = grandTotal.Taxable0;
                                    cellValue = grandTotal.Taxable0 != null
                                        ? Number(grandTotal.Taxable0).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                } else if (col === 'P 3%') {
                                    //  cellValue = grandTotal.Taxable3;
                                    cellValue = grandTotal.Taxable3 != null
                                        ? Number(grandTotal.Taxable3).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                } else if (col === 'GST 3%') {
                                    //cellValue = grandTotal.GST3;
                                    cellValue = grandTotal.GST3 != null
                                        ? Number(grandTotal.GST3).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                } else if (col === 'P 5%') {
                                    //  cellValue = grandTotal.Taxable5;
                                    cellValue = grandTotal.Taxable5 != null
                                        ? Number(grandTotal.Taxable5).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                } else if (col === 'GST 5%') {
                                    //  cellValue = grandTotal.GST5;
                                    cellValue = grandTotal.GST5 != null
                                        ? Number(grandTotal.GST5).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                } else if (col === 'P 12%') {
                                    // cellValue = grandTotal.Taxable12;
                                    cellValue = grandTotal.Taxable12 != null
                                        ? Number(grandTotal.Taxable12).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'GST 12%') {
                                    //cellValue = grandTotal.GST12;
                                    cellValue = grandTotal.GST12 != null
                                        ? Number(grandTotal.GST12).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'P 18%') {
                                    // cellValue = grandTotal.Taxable18;
                                    cellValue = grandTotal.Taxable18 != null
                                        ? Number(grandTotal.Taxable18).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'GST 18%') {
                                    //cellValue = grandTotal.GST18;
                                    cellValue = grandTotal.GST18 != null
                                        ? Number(grandTotal.GST18).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'P 28%') {
                                    //cellValue = grandTotal.Taxable28;
                                    cellValue = grandTotal.Taxable28 != null
                                        ? Number(grandTotal.Taxable28).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'GST 28%') {
                                    // cellValue = grandTotal.GST28;
                                    cellValue = grandTotal.GST28 != null
                                        ? Number(grandTotal.GST28).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'Packing') {
                                    //  cellValue = grandTotal.PackingAmount;
                                    cellValue = grandTotal.PackingAmount != null
                                        ? Number(grandTotal.PackingAmount).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'Pack.GST') {
                                    //cellValue = grandTotal.PackingGST;
                                    cellValue = grandTotal.PackingGST != null
                                        ? Number(grandTotal.PackingGST).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'Freight') {
                                    //cellValue = grandTotal.FreightAmount;
                                    cellValue = grandTotal.FreightAmount != null
                                        ? Number(grandTotal.FreightAmount).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'Freight.GST') {
                                    //cellValue = grandTotal.FreightGSTAmount;
                                    cellValue = grandTotal.FreightGSTAmount != null
                                        ? Number(grandTotal.FreightGSTAmount).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'TCS') {
                                    //cellValue = grandTotal.TCSAmount;
                                    cellValue = grandTotal.TCSAmount != null
                                        ? Number(grandTotal.TCSAmount).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'Round') {
                                    //cellValue = grandTotal.RoundOff;
                                    cellValue = grandTotal.RoundOff != null
                                        ? Number(grandTotal.RoundOff).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'Total') {
                                    //cellValue = grandTotal.TotalAmount;
                                    cellValue = grandTotal.TotalAmount != null
                                        ? Number(grandTotal.TotalAmount).toFixed(2)
                                        : "";
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }
                                else if (col === 'Total') {
                                } else if (col === 'Bill Date') {
                                    cellValue = 'Grand Total';
                                    cellStyle = { fontSize: "12px", padding: "7px", backgroundColor: '#DFF0D8', textAlign: 'right' };
                                }

                                return (
                                    <TableCell key={idx} style={{ padding: '7px', ...cellStyle }}>
                                        {cellValue}
                                    </TableCell>
                                );
                            })}
                        </TableRow>


                        {/* Pagination */}
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[15, 25, 50, 100]}
                                    count={filteredDataItem.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }
}
export default PurchaseRegisterReport;